import React, { SetStateAction, useEffect, useRef, useState } from 'react';
import { BACK_ARROW, INFO_ICON } from '../../assets/icons';
import { useClickOutside } from '../../hooks';
import { Button, RadioButton } from '@wot/components';
import { AddRequirement } from './PostRequirement';

export type TutorCategory = 'standard' | 'premium';
interface IStep2 {
  handleStep2: (data: any) => void;
  setStep: React.Dispatch<SetStateAction<'step-1' | 'step-2'>>;
  requirementData: AddRequirement | undefined;
}

const Step2: React.FC<IStep2> = ({ handleStep2, setStep, requirementData }) => {
  const [tutorCategory, setTutorCategory] = useState<TutorCategory>(requirementData?.category || 'standard');

  const onSubmit = async () => {
    handleStep2({
      category: tutorCategory
    });
  };
  const [infoOpt, setInfoOpt] = useState(false);
  const infoRef = useRef(null);
  useClickOutside(infoRef, () => setInfoOpt(false));

  useEffect(() => {
    const data = localStorage.getItem('RequirementData');
    if (data) {
      const jsonData = JSON.parse(data);
      setTutorCategory(jsonData.tutorCategory);
    }
  }, []);

  function Info() {
    return (
      <div
        ref={infoRef}
        className="max-w-[300px] flex flex-col absolute right-24 bg-neutralBlue2 drop-shadow-lg px-2 py-5 rounded-lg cursor-pointer mt-8 z-50"
      >
        <div className="py-2 px-1 flex gap-3">
          <p className="text-sm font-medium">Standard</p>
          <p className="text-xs">Lorem ipsum dolor amet Lorem ipsum dolor ametLorem ipsum</p>
        </div>
        <div className="py-2 px-1 flex gap-3">
          <p className="text-sm font-medium">Premium</p>
          <p className="text-xs">Lorem ipsum dolor amet Lorem ipsum dolor ametLorem ipsum</p>
        </div>
      </div>
    );
  }
  return (
    <div>
      <div className="flex flex-row justify-start items-center gap-4  my-8">
        <div
          className="w-8 h-8 flex items-center justify-center bg-neutralBlue2 rounded-full cursor-pointer drop-shadow-md"
          onClick={() => setStep('step-1')}
        >
          <img src={BACK_ARROW} alt="Go Back" />
        </div>
        <div className="w-full flex justify-start md:justify-center">
          <h5 className="text-2xl font-semibold">Post a requirement</h5>
        </div>
      </div>

      <div className="flex flex-col gap-8 mt-20 mb-60">
        <div className="flex gap-3">
          <label htmlFor="email" className="text-lg font-medium">
            What tutor tutorCategory you would prefer ?
          </label>
          <img src={INFO_ICON} alt="Info Icon" className="cursor-pointer relative" onMouseUp={() => setInfoOpt(true)} />
          {infoOpt && <Info />}
        </div>
        <RadioButton
          checked={tutorCategory === 'standard'}
          onChange={(x) => x && setTutorCategory('standard')}
          name="radio-buttons"
          label="Standard"
        />
        <RadioButton
          checked={tutorCategory === 'premium'}
          onChange={(x) => x && setTutorCategory('premium')}
          name="radio-buttons"
          label="Premium"
        />
      </div>
      <div className="max-w-md mx-auto">
        <Button block text="Submit" size="lg" onClick={() => onSubmit()} />
      </div>
    </div>
  );
};

export default Step2;
